import { render, staticRenderFns } from "./TrackingNumbers.vue?vue&type=template&id=a84d8bec&scoped=true&"
import script from "./TrackingNumbers.vue?vue&type=script&lang=js&"
export * from "./TrackingNumbers.vue?vue&type=script&lang=js&"
import style0 from "./TrackingNumbers.vue?vue&type=style&index=0&id=a84d8bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d8bec",
  null
  
)

export default component.exports